import { methods, ServiceMaker } from './index';

const { POST } = methods;

export const planmaster = data => ServiceMaker(`v1/api/planmaster/createOrUpdate`, POST, null, data);